import React from "react";
import { Link, NavLink } from "react-router-dom";
import {
  HeaderContainer,
  HeaderContent,
  LogoContainer,
  NavContainer,
} from "./styled";
import { CustomSecondaryButton, CustomButton } from "../physician_page/styled";
import { isLogin, extractToken } from "../../../utils/localStorage";
import { headerMenuItems, roleAccess } from "../../../utils/menu-items";

const Navbar = () => {
  const loggedIn = isLogin();
  let dashboardPath = "/pages/physicians";
  if (loggedIn) {
    const user = extractToken();
    const filteredMenuItems = headerMenuItems.filter(
      (item) => item.visible && roleAccess(user?.role, item.roles)
    );
    
    if (filteredMenuItems.length > 0) {
      // Find the first valid path, traversing children if necessary
      for (const item of filteredMenuItems) {
        if (item.children && item.children.length > 0) {
          const validChild = item.children.find((child) => 
            roleAccess(user?.role, child.roles)
          );
          if (validChild) {
            dashboardPath = validChild.path;
            break;
          }
        } else if (item.path && item.path !== "#") {
          dashboardPath = item.path;
          break;
        }
      }
    }
  }
  return (
    <HeaderContainer className="py-4">
      <HeaderContent>
        <LogoContainer>
          <NavLink to="/">
            <img src="/MUC_logo.png" alt="Logo" />
          </NavLink>
        </LogoContainer>

        <NavContainer>
          <NavLink to="/">Home</NavLink>
          <NavLink to="/pricing">Pricing</NavLink>
          {/* <NavLink to="/support">Support</NavLink> */}
        </NavContainer>

        <div className="custom-button">
          {loggedIn ? (
            <CustomButton
            onClick={() => {
              window.location.href = dashboardPath;
            }}
            >
                Dashboard
            </CustomButton>
          ) : (
            <>
              <CustomSecondaryButton>
                <Link to="/login">
                  Login
                </Link>
              </CustomSecondaryButton>
              <CustomButton>
                <Link to="/pricing">
                  Sign Up
                </Link>
              </CustomButton>
            </>
          )}
        </div>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Navbar;
